import React, {useEffect, useState} from 'react';
import _ from "lodash";
import EditImageSmall from "./edit-image-small";

const EditImagesList = ({imagesList, imageIdsList, setImageIdsList}) => {

    const removeFromSelectedList = (image) => {
        let currentImageIdsList = [...imageIdsList];
        const imageIndex = currentImageIdsList.indexOf(image?.id);
        delete currentImageIdsList[imageIndex];
        currentImageIdsList = _.compact(currentImageIdsList);

        setImageIdsList(currentImageIdsList);
    }

    return (
        <>

            <div
                className="edit-multiple-images-right-list-container overflow-y-scroll mt-4 border border-gray-400 bg-gray-400 rounded">

                {imagesList?.length > 0 &&

                    <div className="flex flex-wrap justify-start p-2">
                        {imagesList?.map((image, index) => (
                            <React.Fragment key={index}>
                                {imageIdsList?.indexOf(image?.id) !== -1 &&
                                    <div
                                        className="flex justify-between place-items-center text-center border bg-gray-100 border-gray-500 rounded m-1">
                                        <div>
                                            {image?.thumbnail &&
                                                <div className="-m-1">
                                                    <EditImageSmall
                                                        imageDetail={image}
                                                        selectedImage={null}
                                                        removeFromSelectedList={removeFromSelectedList}/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        ))}
                    </div>

                }

            </div>

        </>
    )
}

export default EditImagesList
